"use strict";
var callBind = require("call-bind-apply-helpers");
var gOPD = require("gopd");
var hasProtoAccessor;
try {
  hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */
  [].__proto__ === Array.prototype;
} catch (e) {
  if (!e || typeof e !== "object" || !("code" in e) || e.code !== "ERR_PROTO_ACCESS") {
    throw e;
  }
}
var desc = !!hasProtoAccessor && gOPD && gOPD(
  Object.prototype,
  /** @type {keyof typeof Object.prototype} */
  "__proto__"
);
var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;
module.exports = desc && typeof desc.get === "function" ? callBind([desc.get]) : typeof $getPrototypeOf === "function" ? (
  /** @type {import('./get')} */
  function getDunder(value) {
    return $getPrototypeOf(value == null ? value : $Object(value));
  }
) : false;
